<template>
  <div>
    <v-toolbar flat color="white" class="elevation-1">
      <div class="inline-flex w-64">
        <v-select
          class="ml-2 pt-3"
          :items="licenseTypes"
          :placeholder="$t('message.LincensesApprovalPendingComponent.labels.licenseType')"
          item-text="nombre"
          item-value="id"
          v-model="idLicenseTypeSelected"
          @change="getHistory()"
          solo
          flat
          data-vs-select="licenseTypes"
        ></v-select>
      </div>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="historyList"
      :loading="loading"
      class="elevation-1"
      :no-data-text="$t('message.datatable.noDataText')"
    >
      <template v-slot:items="props">
        <td>{{ props.item.tipo_alias }}</td>
        <td><span :class="setColorByStatus(props.item.estado_id)">{{ props.item.estado_alias }}</span></td>
        <td>{{ props.item.fecha_desde }}</td>
        <td>{{ props.item.fecha_regreso }}</td>
        <td>{{ props.item.dias }}</td>
        <td v-html="props.item.observaciones"></td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'

export default {
  props: {
    idUser: {
      type: String,
      default: ''
    },
    idLicenseType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      licenses: Licenses,
      loading: false,
      headers: [
        {
          text: this.$t("message.LincensesHistorySummaryComponent.labels.licenseType2"),
          align: 'left',
          sortable: false,
          value: 'tipo_alias'
        },
        {
          text: this.$t("message.LincensesHistorySummaryComponent.labels.status"),
          align: 'left',
          sortable: false,
          value: 'estado_alias'
        },{
          text: this.$t("message.LincensesHistorySummaryComponent.labels.startDate"),
          align: 'left',
          sortable: false,
          value: 'fecha_desde'
        },{
          text: this.$t("message.LincensesHistorySummaryComponent.labels.return"),
          align: 'left',
          sortable: false,
          value: 'fecha_regreso'
        },{
          text: this.$t("message.LincensesHistorySummaryComponent.labels.days"),
          align: 'left',
          sortable: false,
          value: 'dias'
        },{
          text: this.$t("message.LincensesHistorySummaryComponent.labels.comment"),
          align: 'left',
          sortable: false,
          value: 'observaciones'
        },
      ],
      licenseTypes: [],
      idLicenseTypeSelected: this.idLicenseType,
      historyList: [],
      historyTotal: 0
    }
  },
  computed: {
    setColorByStatus(){
      return (statusId) => {
        if(statusId == 2 || statusId == 3 || statusId ==4){
          return 'text-zt-warning'
        }
        if(statusId == 5){
          return 'text-zt-success'
        }
        if(statusId == 10 || statusId == 9){
          return 'text-zt-dark-400'
        }
        if(statusId == 8){
          return 'text-zt-danger'
        }
      }
    }
  },
  created() {
    this.licenses = new Licenses()
    
    this.licenses.getLicenseTypesManager().then(res => {
      this.licenseTypes = res.data.data
    })
    this.getHistory()
  },
  methods: {
    getHistory() {
      this.loading = true
      this.licenses.getHistoryByType(this.idUser, this.idLicenseTypeSelected)
      .then(res => {
        this.loading = false
        this.historyTotal = res.data.pagination.total
        this.historyList = res.data.results.data
      })
      .catch(error => {
        this.loading = false
      })
    }
  }
}
</script>